import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
import { NAVIGATE_ADMIN, NAVIGATE_AUTH, USER_TYPE } from '../constant';
import Error404 from '../pages/error/Error404';

import AdminRoute from './AdminRoute';
import AuthRoute from './AuthRoute';
import GuestRoute from './GuestRoute';
import RegisterRoute from './RegisterRoute';
import BlankLayout from '../layout/BlankLayout';
import { SettingsProvider } from '../providers/SettingsProvider';

const AgentRoute = lazy(() => import('./AgentRoute'));

const AppRoute = () => {
    return (

        <Suspense fallback={<BlankLayout><LoaderText /></BlankLayout>}>
            <Routes>
                <Route path={`${NAVIGATE_AUTH.AUTH}/*`} element={<AuthRoute />}></Route>
                <Route path={`${NAVIGATE_AUTH.LOGIN}`} element={<Navigate to={NAVIGATE_AUTH.LOGIN_PAGE} />}></Route>
                <Route path={`${USER_TYPE.GUEST}/*`} element={<GuestRoute />}></Route>
                <Route path={`${USER_TYPE.REGISTER}/*`} element={<RegisterRoute />}></Route>
                <Route path={`${USER_TYPE.ADMIN}/*`} element={<SettingsProvider> <AdminRoute /></SettingsProvider>}></Route>
                <Route path={USER_TYPE.ADMIN} element={<Navigate to={NAVIGATE_ADMIN.DASHBOARD_PAGE} />}></Route>
                <Route path={`${USER_TYPE.AGENT}/*`} element={<SettingsProvider> <AgentRoute /></SettingsProvider>}></Route>
                <Route path='*' element={<Error404 />}></Route>
            </Routes>
        </Suspense>

    )
}

export default AppRoute;